<script setup>
import SiteLayout from '@/Layouts/Layout.vue';
import BlocklistLookupForm from '@/Pages/BlocklistLookup/BlocklistLookupForm.vue';
</script>

<template>
  <SiteLayout
    :title="$t('blocklist_lookup.index.blocklist_lookup')"
    :description="$t('blocklist_lookup.index.blocklist_lookup_description')"
  >
    <BlocklistLookupForm />
  </SiteLayout>
</template>
